<template>
  <div>
    <page-header :title="$t('cloudenv.text_560',[actions[this.$route.query.type]])" />
    <page-body needMarginBottom>
      <a-form
        :form="form.fc">
        <a-form-item :label="$t('cloudenv.text_95')" v-bind="formItemLayout" v-if="this.$route.query.type !== 'assign'">
          <a-input v-decorator="decorators.name" :placeholder="$t('cloudenv.text_190')" />
        </a-form-item>
        <a-form-item :label="$t('cloudenv.text_502')" v-bind="formItemLayout" :extra="categoryExtra">
          <a-select
            v-decorator="decorators.category"
            show-search
            option-filter-prop="children"
            :disabled="categoryDisabled">
            <a-select-opt-group v-for="group in categoryGroups" :key="group.key" :label="group.label">
              <a-select-option v-for="item in group.items" :key="item.key" :value="item.key" :label="item.label">{{ item.label }}</a-select-option>
            </a-select-opt-group>
          </a-select>
          <!-- <div v-if="categoryExtra" class="strategy-category-extra">{{ categoryExtra }}</div> -->
        </a-form-item>
        <scope-application v-if="this.$route.query.type === 'assign'" />
        <component
          ref="policyComponent"
          :is="componentName"
          :options="options"
          :present-policies="presentPolicies"
          :disabled="policiesDisabled"
          :category="selectedCategory"
          :label="getLabel()" />
      </a-form>
    </page-body>
    <page-footer>
      <div slot="right">
        <a-button
          class="ml-3"
          type="primary"
          native-type="submit"
          html-type="submit"
          @click="handleConfirm"
          :loading="loading">{{ $t('cloudenv.text_275') }}</a-button>
        <a-button class="ml-3" @click="cancle">{{ $t('common.cancel') }}</a-button>
      </div>
    </page-footer>
  </div>
</template>

<script>
import * as R from 'ramda'
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import {
  isMonitorTemplateCategory,
  MONITOR_TEMPLATE_VMINSTANCE,
  MONITOR_TEMPLATE_HOST,
  MONITOR_TEMPLATE_VMINSTANCE_CONTAINER,
  MONITOR_TEMPLATE_CONTAINER,
  MONITOR_TEMPLATE_RDS,
  MONITOR_TEMPLATE_REDIS,
  MONITOR_TEMPLATE_BLOCKSTORAGE,
  MONITOR_TEMPLATE_BUCKET,
  MONITOR_TEMPLATE_BAREMETAL,
} from '@Monitor/utils/monitorTemplate'
import { categories, categoryGroups, getPolicies, CATEGORY_KEYS } from '../config/index'
import HiddenMenus from './components/HiddenMenus'
import HiddenFields from './components/HiddenFields'
import ConfiguredCallbackAddress from './components/ConfiguredCallbackAddress'
import ScopeApplication from './components/ScopeApplication'
import ServerDuration from './components/ServerDuration'
import MonitorTemplate from './components/MonitorTemplate'

// 各监控模板策略类型的说明文案
const MONITOR_TEMPLATE_TIP_MAP = {
  [MONITOR_TEMPLATE_VMINSTANCE]: 'system.strategydefinition.vminstance_monitor_template_tip',
  [MONITOR_TEMPLATE_HOST]: 'system.strategydefinition.host_monitor_template_tip',
  [MONITOR_TEMPLATE_VMINSTANCE_CONTAINER]: 'system.strategydefinition.vminstance_container_monitor_template_tip',
  [MONITOR_TEMPLATE_CONTAINER]: 'system.strategydefinition.container_monitor_template_tip',
  [MONITOR_TEMPLATE_RDS]: 'system.strategydefinition.rds_monitor_template_tip',
  [MONITOR_TEMPLATE_REDIS]: 'system.strategydefinition.redis_monitor_template_tip',
  [MONITOR_TEMPLATE_BLOCKSTORAGE]: 'system.strategydefinition.blockstorage_monitor_template_tip',
  [MONITOR_TEMPLATE_BUCKET]: 'system.strategydefinition.bucket_monitor_template_tip',
  [MONITOR_TEMPLATE_BAREMETAL]: 'system.strategydefinition.baremetal_monitor_template_tip',
}

export default {
  name: 'CreateStrategyDefinitionIndex',
  components: {
    HiddenMenus,
    ConfiguredCallbackAddress,
    ScopeApplication,
    HiddenFields,
    ServerDuration,
    MonitorTemplate,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      templatePanels: [],
      form: {
        fc: this.$form.createForm(this, {
          onValuesChange: (props, values) => {
            if (R.has('category', values)) {
              R.forEach((item) => {
                if (item.key === values.category) this.componentName = item.component
              }, categories)
              this.selectedCategory = values.category
            }
          },
        }),
      },
      decorators: {
        name: [
          'name',
          {
            rules: [
              { required: true, message: this.$t('cloudenv.text_190') },
            ],
          },
        ],
        category: [
          'category',
          {
            initialValue: categories[0].key,
            rules: [
              { required: true, message: this.$t('cloudenv.text_553') },
            ],
          },
        ],
      },
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      categories,
      categoryGroups,
      selectedCategory: categories[0].key,
      componentName: 'HiddenMenus',
      actions: {
        create: this.$t('cloudenv.text_104'),
        edit: this.$t('cloudenv.text_554'),
        assign: this.$t('cloudenv.text_555'),
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'scope', 'userInfo']),
    // 策略类型为监控模板时，补充配置与生效规则的说明
    categoryExtra () {
      const tipKey = MONITOR_TEMPLATE_TIP_MAP[this.selectedCategory]
      return tipKey ? this.$t(tipKey) : ''
    },
    options () {
      const policies = getPolicies()
      return policies[this.selectedCategory]
    },
    presentPolicies () {
      if (this.$route.query.type !== 'create' && this.$route.query.policies) return this.$route.query.policies
      return {}
    },
    categoryDisabled () {
      return this.$route.query.type !== 'create'
    },
    policiesDisabled () {
      return this.$route.query.type === 'assign'
    },
  },
  provide () {
    return {
      form: this.form,
    }
  },
  created () {
    this.setInitValue()
  },
  methods: {
    setComponentName (category) {
      const hit = categories.find(item => item.key === category)
      if (hit) this.componentName = hit.component
    },
    setInitValue () {
      if (this.$route.query.type === 'edit') {
        const { name, category } = this.$route.query
        this.setComponentName(category)
        this.selectedCategory = category
        this.$nextTick(() => {
          this.form.fc.setFieldsValue({
            name,
            category,
          })
        })
      } else if (this.$route.query.type === 'assign') {
        const { category } = this.$route.query
        this.setComponentName(category)
        this.selectedCategory = category
        this.$nextTick(() => {
          this.form.fc.setFieldsValue({
            category,
          })
        })
      }
    },
    genData (values) {
      const { name, category } = values
      if (this.$route.query.type === 'assign') {
        return {
          name,
          scope: values.scope,
          target_ids: values.projects || values.domains,
        }
      }
      const ret = {
        name,
        category,
        policies: {},
      }
      if (isMonitorTemplateCategory(category)) {
        // 监控模板只保存面板配置，策略分配到范围后该范围内全部虚拟机生效
        ret.policies = { panels: this.templatePanels }
      } else if (R.has('hiddenMenus', values)) {
        values.hiddenMenus.map(item => {
          ret.policies[item] = true
        })
      } else if (R.has('hiddenFields', values)) {
        values.hiddenFields.map(item => {
          ret.policies[item] = true
        })
      } else {
        const _values = R.clone(values)
        delete _values.name
        delete _values.category
        ret.policies = { ..._values }
      }
      if (this.$route.query.type === 'edit') delete ret.category
      return ret
    },
    doCreate (data) {
      return new this.$Manager('scopedpolicies', 'v1').create({ data })
    },
    doUpdate (data) {
      return new this.$Manager('scopedpolicies', 'v1').update({
        data,
        id: this.$route.query.id,
      })
    },
    doAssign (data) {
      return new this.$Manager('scopedpolicies', 'v1').performAction({
        data,
        id: this.$route.query.id,
        action: 'bind',
      })
    },
    async handleConfirm () {
      this.loading = true
      try {
        const values = await this.form.fc.validateFields()
        if (isMonitorTemplateCategory(values.category)) {
          const panels = await this.$refs.policyComponent.getPanels()
          if (!panels) {
            this.loading = false
            return
          }
          this.templatePanels = panels
        }
        const data = this.genData(values)
        const { type } = this.$route.query
        if (R.isEmpty(data.policies) && data.category.includes('configured_callback_address')) {
          this.loading = false
          this.$message.warn(this.$t('cloudenv.text_556'))
          return
        }
        if (type === 'create') {
          await this.doCreate(data)
        } else if (type === 'edit') {
          await this.doUpdate(data)
        } else if (type === 'assign') {
          await this.doAssign(data)
        }
        this.loading = false
        this.$message.success(this.$t('cloudenv.text_324', [this.actions[type]]))
        if (type === 'assign') {
          this.$router.push('/strategyallocation')
        } else {
          this.$router.push('/strategydefinition')
        }
      } catch (error) {
        this.loading = false
      }
    },
    cancle () {
      this.$router.push('/strategydefinition')
    },
    getLabel () {
      if (this.selectedCategory === CATEGORY_KEYS.DOCUMENT_CONFIGURED_CALLBACK_ADDRESS) {
        return this.$t('system.strategydefinition.document_callback_address')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .strategy-category-extra {
    margin-top: 6px;
    font-size: 13px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.45);
  }
  ::v-deep .ant-checkbox-group {
    width: 800px;
    .ant-checkbox-group-item {
      width: 150px;
      margin-bottom: 20px;
    }
  }
</style>
